module.exports = __webpack_public_path__ + "static/img/Opportunities_EnjoyingLA_Museums.2fa65e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Opportunities_EnjoyingLA_Museums.jpg
// module id = gPoh
// module chunks = 1